import { Layout, Tabs } from 'antd'
import { useGlobalAuth } from '@headbox-ui/auth-hook'
import React, { FC, ReactElement, useEffect, useState } from 'react'
import { EventActiveArg } from '../../types'
import { Booking } from './Booking'
import { TeamEvents } from './TeamEvents'
import { EventHubEventFragment, useEventHubEventsQuery } from './EventHub.generated-types'
import { SideBar } from './SideBar'

const { Content, Sider } = Layout

export const EventHub: FC = (): ReactElement => {
  const { user } = useGlobalAuth()

  const [selectedEventListItem, setSelectedEventListItem] = useState<EventHubEventFragment>()

  const [{ fetching: activeLoading, error: activeError, data: activeData }, refetchActive] =
    useEventHubEventsQuery({
      variables: { active: EventActiveArg.Active, sort: { fromDateTimeAscending: false } },
      requestPolicy: 'cache-and-network',
    })

  const [{ fetching: inactiveLoading, error: inactiveError, data: inactiveData }, refetchInactive] =
    useEventHubEventsQuery({
      variables: { active: EventActiveArg.Inactive, sort: { fromDateTimeAscending: false } },
      requestPolicy: 'cache-and-network',
    })

  useEffect(() => {
    if (activeData?.getEventsByUser) {
      if (activeData?.getEventsByUser.length > 0) {
        setSelectedEventListItem(activeData.getEventsByUser[0])
      } else if (inactiveData?.getEventsByUser.length > 0) {
        setSelectedEventListItem(inactiveData.getEventsByUser[0])
      }
    }
  }, [activeData, inactiveData])

  const onCancelEventSuccess = async (): Promise<any> => {
    return await Promise.all([refetchActive(), refetchInactive()])
  }

  const loadingActiveEvents = activeLoading && !activeData
  const loadingInactiveEvents = inactiveLoading && !inactiveData

  const hasNoEvents =
    activeData?.getEventsByUser?.length < 1 && inactiveData?.getEventsByUser?.length < 1

  const eventsLoading =
    (activeLoading || inactiveLoading) && activeData != null && inactiveData != null

  const userHasTeams = user?.teams?.length > 0

  const myEvents = (
    <Layout>
      <div className='sidebar-wrapper' style={{
        position: 'fixed',
        // 65px ensures the sidebar sits just below the header and ensures the scrollbar doesn't get cut off at the top
        top: userHasTeams ? '120px' : '65px',
        left: '0px',
        // 66px allows for the height of the scroll bar, otherwise it gets slightly cut off at the bottom
        height: userHasTeams ? 'calc(100vh - 126px)' : 'calc(100vh - 66px)',
        width: 'calc((100vw - 1278px) / 2 + 309px)',
        overflow: 'auto',
        background: '#fff'
      }}>
        <Sider width={309} style={{ marginLeft: 'auto' }}>
          <SideBar
            activeLoading={loadingActiveEvents}
            activeError={activeError}
            activeEvents={activeData?.getEventsByUser}
            inactiveLoading={loadingInactiveEvents}
            inactiveError={inactiveError}
            inactiveEvents={inactiveData?.getEventsByUser}
            setSelectedEventListItem={setSelectedEventListItem}
            selectedEventListItem={selectedEventListItem}
          />
        </Sider>
      </div>
      <Content style={{
        margin: '40px 0px 36px 358px'
      }}>
        <Booking
          selectedEventUUID={selectedEventListItem?.UUID}
          onCancelEventSuccess={onCancelEventSuccess}
          hasNoEvents={hasNoEvents}
          eventsLoading={eventsLoading}
        />
      </Content>
    </Layout>
  )

  const teamEvents = (
    <Content>
      <TeamEvents />
    </Content>
  )

  if (userHasTeams) {
    return (
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{
          width: '100%',
          backgroundColor: '#fff',
          margin: '0px',
          top: '65px',
          left: '0px',
          position: 'fixed',
          zIndex: '999',
          paddingLeft: 'calc((100vw - 1278px) / 2)'
        }}
        items={[
          { key: '1', label: 'Your events', children: <div style={{ marginTop: 65 }}>{myEvents}</div> },
          { key: '2', label: 'Team events', children: <div style={{ marginTop: 65 }}>{teamEvents}</div> }]}
      />

    )
  } else return myEvents
}
